import _extends from "@babel/runtime/helpers/extends";
import styled from "@emotion/styled";
import React, { forwardRef, useMemo } from "react";
const VisuallyHiddenRoot = styled("span")`
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%); // TODO do we need this?
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;

    // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
    white-space: nowrap;
    word-wrap: normal;
`;
/**
 * Adapted from https://github.com/reach/reach-ui/blob/main/packages/visually-hidden/src/index.tsx
 *
 * Provides text for screen readers that is visually hidden.
 * It is the logical opposite of the `aria-hidden` attribute.
 */
export const VisuallyHidden = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    clientId,
    renderAs,
    ...rest
  } = _ref;
  const TheComponent = useMemo(() => renderAs ? VisuallyHiddenRoot.withComponent(renderAs) : VisuallyHiddenRoot, [renderAs]);
  return /*#__PURE__*/React.createElement(TheComponent, _extends({}, rest, {
    "data-client-id": clientId,
    ref: ref
  }));
});
VisuallyHidden.displayName = "VisuallyHidden";
//# sourceMappingURL=VisuallyHidden.js.map